import { HttpHeaders } from "@angular/common/http";

import { environment } from "../../../environments/environment";

/**
 * Request header read by the API's RegionProxyMiddleware. When present, the
 * local API proxies the request to the region whose hostname matches the value,
 * forwarding the user's identity as a short-lived inter-region JWT. This lets
 * cookie-authenticated UI sessions query other regions without relying on
 * cross-domain cookies.
 */
export const PROXY_ORIGIN_HEADER = "X-DU-Proxy-Origin";

/**
 * Builds the headers needed to route a request through the back-end
 * cross-region proxy. Returns the {@link PROXY_ORIGIN_HEADER} (set to the target
 * region's hostname) when the region differs from the local API; otherwise
 * returns empty headers so the local API handles the request directly.
 *
 * @param regionUrl - The selected region's URL (with or without a trailing slash).
 */
export function buildRegionProxyHeaders(regionUrl?: string): HttpHeaders {
  const targetHostname = hostnameOf(regionUrl);
  const localHostname = hostnameOf(environment.developmentUrl);

  if (targetHostname && targetHostname !== localHostname) {
    return new HttpHeaders().set(PROXY_ORIGIN_HEADER, targetHostname);
  }

  return new HttpHeaders();
}

function hostnameOf(url?: string): string | null {
  if (!url) {
    return null;
  }
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}
